<script setup lang="ts">
import SocketService, {SocketState} from "@/services/SockerService";
import {useTranslate} from "@tolgee/vue";
import {computed} from "vue";

const socketService = SocketService.getInstance();

const { socketState } = socketService;

const { t } = useTranslate();

const text = computed(() => {
	return socketState.value === SocketState.CONNECTED ? t.value('connection.true') : t.value('connection.false');
});
</script>

<template>
	<div v-if="socketState" class="socket-toast-state">
		<Transition name="slide-fade" mode="out-in">
			<div
				:key="socketState"
				class="socket-toast-state__message"
				:class="socketState"
			>
				<i :class="socketState === SocketState.CONNECTED ? 'icon svg-success' : 'icon svg-warning'"></i>
				<div>{{ text }}</div>
			</div>
		</Transition>
	</div>
</template>

<style scoped lang="scss">
.socket-toast-state {
	position: absolute;
	display: flex;
	justify-content: center;
	z-index: 10000;
	top: calc(6px + var(--f7-safe-area-top));
	left: 50%;
	transform: translateX(-50%);

	&__message {
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 12px;
		border-radius: 18px;
		white-space: nowrap;
		box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);

		i {
			width: 18px;
			height: 18px;
		}

		&.connected {
			color: #32BF61;
			background-color: #D9F1DF;
		}

		&.disconnected {
			color: #CF7529;
			background-color: #FCF5E5;
		}
	}
}


.slide-fade-enter-active,
.slide-fade-leave-active {
	transition: all 0.2s ease-in-out;
}

.slide-fade-enter-from {
	opacity: 0;
	transform: translateY(-120%);
}
.slide-fade-leave-to {
	opacity: 0;
	transform: translateY(-120%);
}
</style>
